/**
 * created by xcc
 * 阵地危险处置
 *
 */
import React from 'react';
import {getContributeListBtn} from "./safetyManageConfig";
import {Button, Checkbox} from "antd";
import InteractBtn from "./components/interactBtn";
import PositionSafetyManage from "./PositionSafetyManage";
import DangerDisposeDetail from "./components/dangerDisposeDetail";
import {generateColumns} from "../../../newMediaMatrix/components/utils";

export default class DangerDispose extends PositionSafetyManage {

    selectList() {
        let sysConfig = JSON.parse(this.sysConfig);
        const securityType = sysConfig ? sysConfig.map(item => ({
            key: item.key,
            name: item.name,
            child: item.child.map(subItem => ({
                key: subItem.trim(),
                name: subItem.trim()
            }))
        })) : [];
        const category = this.state.params.securityType && securityType ? securityType.find(item => item.key === this.state.params.securityType)?.child : [];
        const baseColumns = [
            {
                type: 2,
                component: 'select',
                labelName: "媒体平台",
                placeholder: '媒体平台',
                labelCode: 'positionTypeId',
                value: this.state.params.positionTypeId || undefined,
                selectValues: this.state.typeData,
                onChange: (val) => {
                    this.onChange('positionTypeId', val)
                },
                style: {width: 150},
                styleOut: {
                    paddingTop: 0
                },
            },
            {
                type: 2,
                component: 'select',
                labelName: "提醒状态",
                placeholder: '提醒状态',
                labelCode: 'remindStatus',
                value: (this.state.params.remindStatus || this.state.params.remindStatus === 0) ? this.state.params.remindStatus : undefined,
                selectValues: [
                    {key: 0, name: "已忽略"},
                    {key: 1, name: "未提醒"},
                    {key: 2, name: "已提醒"}
                ],
                onChange: (val) => {
                    this.onChange('remindStatus', val)
                },
                style: {width: 150},
                styleOut: {
                    paddingTop: 0
                },
            },
            {
                type: 2,
                component: 'select',
                labelName: "风险类型",
                placeholder: '风险类型',
                labelCode: 'remindStatus',
                value: this.state.params.securityType || undefined,
                selectValues: securityType,
                onChange: (val) => {
                    this.state.params.category = "";
                    this.onChange('securityType', val)
                },
                styleOut: {
                    paddingTop: 0
                },
                style: {
                    width: 160,
                    borderRadius: 5,
                }
            },
            {
                type: 2,
                component: 'select',
                labelName: "风险等级",
                placeholder: '风险等级',
                labelCode: 'riskLevel',
                value: (this.state.params.riskLevel || this.state.params.riskLevel === 0) ? this.state.params.riskLevel : undefined,
                selectValues: this.riskLevelList,
                onChange: (val) => {
                    this.onChange('riskLevel', val)
                },
                styleOut: {
                    paddingTop: 0
                },
                style: {
                    width: 160,
                    borderRadius: 5,
                }
            },
            {
                type: 1,
                component: <Button onClick={() => {
                    this.state.params = {
                        page: 1,
                        size: 10
                    };
                    this.refreshList();
                }}>重置</Button>,
                styleOut: {
                    paddingTop: 0
                },
            }
        ];
        const dynamicColumns = [
            {
                type: 2,
                component: 'select',
                labelName: "敏感信息",
                placeholder: securityType.map(item => item.key === this.state.params.securityType ? item.name : ""),
                labelCode: 'category',
                value: this.state.params.category || undefined,
                selectValues: category,
                onChange: (val) => {
                    this.onChange('category', val)
                },
                checkFunction: () => {
                    return this.state.params.securityType;
                },
                position: 3,
                styleOut: {
                    paddingTop: 0
                },
                style: {
                    width: 290,
                    borderRadius: 5,
                }
            },
        ];
        return [generateColumns(baseColumns, dynamicColumns)]
    }

    getHeaderColumns() {
        let {listData, batchRemindStatus, batchIgnoreStatus} = this.state;
        let canCheckList = [];
        let disabledAll = false;
        if (batchRemindStatus) {
            canCheckList = listData.filter(item => item.disposeStatus === 1 || item.disposeStatus === 4)
        }
        if (batchIgnoreStatus) {
            canCheckList = listData.filter(item => item.disposeStatus === 1 || item.disposeStatus === 4)
        }
        if(!canCheckList?.length) {disabledAll = true}
        return {
            title: (() => {
                let checkedAll = canCheckList.length ? canCheckList.every(item => item.checked) : false;
                let checkedLength = canCheckList.length ? canCheckList.filter(item => item.checked).length : 0
                let indeterminate = canCheckList.length && checkedLength > 0 && checkedLength < canCheckList.length;
                return (
                    <Checkbox checked={checkedAll} disabled={disabledAll} indeterminate={indeterminate} onChange={(e) => {
                        this.state.listData.forEach(item => {
                            if (batchRemindStatus && (item.disposeStatus === 1 || item.disposeStatus === 4)) {
                                item.checked = e.target.checked;
                            }
                            if (batchIgnoreStatus && (item.disposeStatus === 1 || item.disposeStatus === 4)) {
                                item.checked = e.target.checked;
                            }
                        });
                        this.setState({})
                    }}/>
                )
            })(),
            align: 'center',
            width: 50,
            key: "checked",
            render: (record) => {
                let disabled = false;
                if (batchRemindStatus && record.disposeStatus !== 1 && record.disposeStatus !== 4) {
                    disabled = true;
                }
                if (batchIgnoreStatus && record.disposeStatus !== 1 && record.disposeStatus !== 4) {
                    disabled = true;
                }
                return (
                    <div>
                        <Checkbox disabled={disabled} checked={record.checked} onChange={() => {
                            record.checked = !record.checked;
                            this.setState({})
                        }}/>
                    </div>
                )
            }
        }
    }

    toggleBatchRemindStatus = (batchRemindStatus) => {
        if (batchRemindStatus) {
            this.state.listData.forEach(item => {
                item.checked = item.disposeStatus === 1 || item.disposeStatus === 4;
            });
        } else {
            this.state.listData.forEach(item => {
                item.checked = false
            });
        }

        this.setState({
            batchRemindStatus,
            batchIgnoreStatus: false
        })
    }

    toggleBatchIgnoreStatus = (batchIgnoreStatus) => {
        if (batchIgnoreStatus) {
            this.state.listData.forEach(item => {
                item.checked = item.disposeStatus === 1 || item.disposeStatus === 4;
            });
        } else {
            this.state.listData.forEach(item => {
                item.checked = false
            });
        }
        this.setState({
            batchIgnoreStatus,
            batchRemindStatus: false
        })
    }

    operateList() {
        let {
            batchRemindStatus,
            batchIgnoreStatus,
        } = this.state;
        return [
            [
                {
                    type: 1,
                    component: <Button onClick={() => {
                        this.exportTable();
                    }}>导出表格</Button>,
                    styleOut: {}
                },
                {
                    type: 1,
                    component: <InteractBtn key={"batchRemind"}
                                            showName={"批量已处理"}
                                            okName={"确定提交"}
                                            status={batchRemindStatus}
                                            toggleStatus={this.toggleBatchRemindStatus}
                                            confirm={() => {
                                                this.confirm(2, "批量已处理", batchRemindStatus)
                                            }}
                    />,
                    styleOut: {display: batchIgnoreStatus ? "none" : "block"}
                },
                {
                    type: 1,
                    component: <InteractBtn key={"batchIgnore"}
                                            showName={"批量非问题"}
                                            okName={"确定提交"}
                                            status={batchIgnoreStatus}
                                            toggleStatus={this.toggleBatchIgnoreStatus}
                                            confirm={() => {
                                                this.confirm(5, "批量非问题")
                                            }}
                    />,
                    styleOut: {display: batchRemindStatus ? "none" : "block"}
                }
            ]
        ]
    }

    renderPmsActionButton(record) {
        return getContributeListBtn.map((item, index) => {
            return this.renderButton(record, item)
        })
    }

    renderDetail() {
        return(
            <DangerDisposeDetail ref={ref => this.dangerDisposeDetail = ref} refreshList={(reset) => this.refreshList(reset)} typeData={this.state.typeData}/>
        )
    }
}